import styled from '@emotion/styled';
import { Box } from 'styles/layout';

const FilterElement = styled(Box)`
  width: 200px;
  margin: 0 1rem 1rem 0;
`;

export default FilterElement;
